import { SEARCH_USERS, SET_LOADING, GET_USER, GET_REPOS, SET_QUERY } from "../types";

export default (state, action) => {
  switch (action.type) {
    case SEARCH_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false
      };
    case SET_QUERY:
      return {
        ...state,
        query: action.payload
      };
    case GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false
      };

    case GET_REPOS:
      return {
        ...state,
        repos: action.payload,
        loading: false
      };

    case SET_LOADING:
      return {
        ...state,
        loading: true
      };

    default:
      return state;
  }
};
